<template>
  <span class="echarts-top5">
    <div id="main"></div>
  </span>
</template>

<script>
  import * as echarts from 'echarts'
  export default {
    props: {
      data: {
        type: Array,
        default () {
          return [{
            id:1,
            name: '信成二期项目',
            value: 23890,
          },
          {
            id:2,
            name: '信成一期项目',
            value: 3466,
          },
          {
            id:3,
            name: '梯次电池整车事业部项目',
            value: 2332,
          },
          {
            id:4,
            name: '大连国网项目',
            value: 667,
          },
          {
            id:5,
            name: '信成二期项目',
            value: 123,
          },
        ]
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      reset(){
        this.$nextTick(function(){
          var myChart = echarts.init(document.getElementById('main'));
          let tmp = this.init();
          myChart.setOption(tmp);
        })
      },
      init(){
        let dataX = this.data;
        let op = {
          grid: {
            top: '10%',
            bottom: '0%',
            right: 10,
            left: 0,
            containLabel: true,
          },
          xAxis: {
            show: false,
          },
          yAxis: [{
              triggerEvent: true,
              show: true,
              inverse: true,

              data: COMM.getArrByKey(dataX, 'id'),
              axisLine: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: true,
                interval: 0,
                color: '#fff',
                backgroundColor:{
                  image:'/static/images/svolt/circle-icon.png',
                },
                align: 'left',
                margin: 40,
                formatter: function(value, index) {
                  return '{title|' +value + '}';
                },
                rich: {
                  title: {
                    width: 24,
                    height:24,
                    align: 'center',
                    fontSize: 16,
                  },
                },
              },
            },
            {
              triggerEvent: true,
              show: true,
              inverse: true,
              data: COMM.getArrByKey(dataX, 'name'),
              axisLine: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                interval: 0,
                shadowOffsetX: '120',
                color: ['#fff'],
                lineHeight: 40,
                fontSize: 16,
                formatter: function(value, index) {
                  return dataX[index].value;
                },
              },
            },
          ],
          series: [{
              name: 'XXX',
              type: 'pictorialBar',
              symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAZlBMVEUAAABe3uVe3+Vf3uVf3+Zf3uVg3+Zg3+Zf3+Vi4OZh4OZg3+Z86/Bh3+Zi4Odj4Odi4OZ86/B76/B86/Bj4ed56+9x5+xn4umB7/N87PB36e+A7/N+7fF/7vJ/7vJ+7fGA7/OB7/PReX+lAAAAIXRSTlMABQkVDREmIhk3MR10LEFFPHh7cUprXE35h2XnqMLAp+mHAG9cAAAB5ElEQVRIx83WjU7CMBQFYIoiKMqU/XUboHv/l/Tce7t2XamDNSacETEmX86tlK2rx4py150o+MstMBLwWRfHKo6JCVxLnvmFGBjFQ58oF1//sUZhGy/ClSTWObgnL4O+bkeN4nY2okfNMbkRt9/vtxz8InoTsWplJSCzFxPmO8+GpSIByX3YQAuGDWtRKhKjCnxDXhF6Z4yxnZ20Wgko7BMRDmxtSGVaI4kdTIgb+zTYoJQlIMlDlmUFgrcDWWC201qSayqlTkiCddWWeV62VU0YlnpRi9VOKaSUsiyq/N0krwq2Ugt7lVpZl5BfHNiytjagMi+XYp0kCR45hMlivVQrE/uU5pXSrCB5bM6d1t2lOZItMqmliT3q5uVxqxzyW/ccfYLNKx7ZTeykMvNyac2yt2Fbc61MHLSC0rwoxbiNdlQ3GBm1NLHQsHUrtEXppR/ljNpW6DbSCoqlFiVoN6YdaFlgsSFVPs1BdT8OaB5QyQzVcaqWDows/zepxR8ObLglTrdtCRVuRNj4Rrxh+//0ke2f8KVL+Kon3GCSbmsJN9OUW3j6g0Ns+LgCij2u0h+Sghc8mlMPBMgdx5DFh59VmOVHrvmDnoNxCz3J7MFWsMuaLyR089xz/xhlfijvwutR8gv3zk6BLUUeCgAAAABJRU5ErkJggg==',
              symbolSize: [50, 50],
              symbolOffset: [20, 0],
              z: 12,
              itemStyle: {
                  color: '#fff',
              },
              data: COMM.getSymbolData(dataX),
            },
            {
              name: '条',
              type: 'bar',
              showBackground: true,
              // barBorderRadius: 30,
              yAxisIndex: 0,
              data: dataX,
              // barWidth: 10,
              barCategoryGap:'80%',
              // align: left,
              itemStyle: {
                normal: {
                  color: 'rgba(41, 162, 245, 1)',
                  // barBorderRadius: 10
                },
                // color: '#A71A2B',
                // barBorderRadius: 4,
              },
              label: {
                  normal: {
                      color: '#fff',
                      show: true,
                      position: ["0px", "-14"],
                      textStyle: {
                          fontSize: 11
                      },
                      formatter: function(a, b) {
                          return a.name
                      }
                  }
              }
            },
          ],
        }
        this.options = op;
        return op;
      }
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  .echarts-top5 {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    #main{
      width:100%;
      height:100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/echarts-top5.vue